import { AgentConfigResponse } from '../models/AgentConfig';
import { BaseService } from './BaseService';

/**
 * Service for fetching agent configuration data from the backend.
 * Used by the AgentConfigPanel for runtime agent configuration.
 */
export class AgentConfigService extends BaseService {
    private static readonly API_PATH = '/api/agents';

    /**
     * Gets available workflow agents and provider configurations.
     */
    public readonly getAgentConfigAsync = async (): Promise<AgentConfigResponse> => {
        const response = await this.getResponseAsync<AgentConfigResponse>({
            commandPath: `${AgentConfigService.API_PATH}/config`,
        });

        return response;
    };
}
